import React, { useCallback, useContext, useState } from 'react'
import CarContext from '../../context/CarContext'
import { TagManager } from '../../../helpers/TagManager';
import enhancedPropertiesInformation from '../../../helpers/enhancedPropertiesInformation';

const EnhancedProperties = () => {

	const { car } = useContext(CarContext)
	const enhancedProperties = car.enhancedProperties



	const extendedProperties = {

		extended_manufacturer: {
			name: "Varumärke",
			type: "text",
			value: car.manufacturer,
			category: {
			  id: 1000,
			  name: "Basuppgifter"
			}
		},
		extended_modelSeries: {
			name: "Modell",
			type: "text",
			value: car.modelSeries,
			category: {
			  id: 1000,
			  name: "Basuppgifter"
			}
		},
		extended_modelYear: {
			name: "Modellår",
			type: "text",
			value: car.modelYear,
			category: {
			  id: 1000,
			  name: "Basuppgifter"
			}
		},
		extended_gearboxType: {
			name: "Växellåda",
			type: "text",
			value: car.gearboxType,
			category: {
			  id: 1000,
			  name: "Basuppgifter"
			}
		},
		extended_color: {
			name: "Färg",
			type: "text",
			value: car.properties.colorName ?? '-',
			category: {
			  id: 1000,
			  name: "Basuppgifter"
			}
		},
		extended_regNo: {
			name: "Registreringsnummer",
			type: "text",
			value: car.registrationNumber,
			category: {
			  id: 1000,
			  name: "Basuppgifter"
			}
		},
		extended_fuelTypes: {
			name: "Drivmedel",
			type: "text",
			value: car.fuelTypes,
			category: {
			  id: 1000,
			  name: "Basuppgifter"
			}
		},
		extended_engineBaseType: {
			name: "Motortyp",
			type: "text",
			value: car.engineBaseType,
			category: {
			  id: 1000,
			  name: "Basuppgifter"
			}
		}
	}

	const propertyCategories = [];
	const propertyData = [];
	const combinedEnhancedProperties = Object.assign(extendedProperties, enhancedProperties);

	// Combine with propertyinformation object
	Object.keys(combinedEnhancedProperties).forEach((key) => {
		const property = combinedEnhancedProperties[key];
		property.information = enhancedPropertiesInformation[property.name] ?? false;
		combinedEnhancedProperties[key] = property;
	});

	let hasTriggered = false

	Object.values(combinedEnhancedProperties).forEach( (value, index) => {
		
		if(value.category && value.category.id !== undefined) {
			let id = value.category.id ;
			value.key = value.category.name;
			if( value.category.name === 'Other') {
				value.key = 'Övrigt';	
			}
			propertyCategories[id] = { id, name: value.key}
	
			if( propertyData[id] === undefined ) { propertyData[id] = []}
			propertyData[id].push(value);
		}

	});
	// console.dir(propertyCategories)
	
	// Sort by cat id in DESC Basuppgifter = 1000
	propertyCategories.sort((a,b)=>{ 
		if( a.name < b.name)
			return -1
		else if( a.name > b.name)
			return 1
		
		return 0;
	});


	const [currentTab, setCurrentTab] = useState( propertyCategories[0].id );


	return (
		<>
			<div className="tabs-titles">
				<ul>
					{ propertyCategories.map((category, index) => {
						// Skip specific car data category
						if(category.name !== 'Specifik fordonsdata') {

							return(
								<li key={category.id} >
									<a 
									className={currentTab === category.id ? 'current' : ''}
									onClick={ (e)=>{ 
										e.preventDefault();
										if (!hasTriggered) {
											// Trigger event, once
											TagManager({event:'CarInfo'})
											hasTriggered = true
										}
										setCurrentTab(category.id); 
									} } href={ 'tabid-'+ category.id}
										>
											{category.name}
									</a>
								</li>
							)
						}
					})}
				</ul>
			</div>
			<TabContent currentTab={currentTab} propertyData={propertyData} />
		</>
	)
}
export default EnhancedProperties


const TabContent = ({currentTab, propertyData}) => {

	const { setModal } = useContext(CarContext)

	const handleModal = useCallback(({text, title})=> {
		setModal( { show: true, title, text })
	},[setModal])

	return (
		<ul className='named-details'>
			{ propertyData[currentTab] !== undefined && propertyData[currentTab].map( (d,j)=> {
				// Skip if no value is defined
				if ( d.value === undefined) {
					return '';
				}

				let value;
				if(d.type === 'bool') {
					value =  d.value ? 'Ja':'Nej' ;
				} else { // number or text
					value =  d.value + (d.unit !== undefined ? ' ' + d.unit:'');
				}

				if(d.information) {
					return (
						<li key={currentTab + '_' + j}>
							<span className='title'>
								<span className=" has_info" onClick={(e)=>{ handleModal({text: d.information, title: d.name }) }}>
								{d.name}
								</span>
							</span>
							<span>{value}</span>
						</li>
					)
				} else {
					return (
						<li key={currentTab + '_' + j}>
							<span className='title'>{d.name}</span>
							<span>{value}</span>
						</li>
					)
				}
			})}
		</ul>		
	)
}
